import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
interface RoomsMenuProps {
  isOpen: boolean;
  onSelect: (room: string) => void;
  onClose: () => void;
}
const rooms = ['Kitchen', 'Basement', 'Primary Bedroom', 'Ensuite', 'Laundry', 'Bedroom 2', 'Bedroom 3', 'Living Room'];
export function RoomsMenu({
  isOpen,
  onSelect,
  onClose
}: RoomsMenuProps) {
  return <AnimatePresence data-id="element-503">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-20" data-id="element-504" />
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="absolute bottom-16 right-6 z-30 w-64 bg-slate-900/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden" data-id="element-505">
            <div className="p-4 border-b border-white/10 bg-white/5" data-id="element-506">
              <h3 className="text-white font-medium text-sm uppercase tracking-wider" data-id="element-507">
                Teleport
              </h3>
            </div>
            <div className="py-2 max-h-[300px] overflow-y-auto" data-id="element-508">
              {rooms.map(room => <button key={room} onClick={() => onSelect(room)} className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-white/70 hover:text-white hover:bg-white/10 transition-colors group" data-id="element-509">
                  <MapPin className="w-4 h-4 text-cyan-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-510" />
                  <span className="text-sm" data-id="element-511">{room}</span>
                </button>)}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}